@if (control()) {
  <label
    class="form-check form-check-custom form-check-inline cursor-pointer"
    [class]="class()"
  >
    <input
      class="form-check-input cursor-pointer input-switch"
      type="checkbox"
      [formControl]="formControl"
    />
    <span class="fw-semibold ps-2 fs-6">{{ placeholder() }}</span>
  </label>
}
@if (!control()) {
  <label
    class="form-check form-check-custom form-check-inline cursor-pointer d-flex align-items-start"
    [class]="class()"
  >
    <input
      class="form-check-input cursor-pointer input-switch"
      type="checkbox"
      [(ngModel)]="modelInput"
      (change)="changeCheckbox.emit($event.target.checked)"
    />
    <span class="fw-semibold ps-2 fs-6">{{ placeholder() }}</span>
  </label>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
